import api from "../../config/client.axios.api";

export const createVoucherApi = async (infoCreate: any) => {
  const response = await api.post(`/voucher`, infoCreate);
  return response.data;
};
